module.exports = __webpack_public_path__ + "img/404.612d0dd8.svg";